import {
    AssistantBill,
    AssistantCompany,
    AssistantCustomer,
    AssistantReservation,
    AssistantResource,
    AssistantSearchResult,
} from '@mews-commander/data-access';
import {
    BillFilter,
    CompanyFilter,
    CustomerFilter,
    ReservationFilter,
    SpaceFilter,
} from '../../assistantSearchTypeFilters';
import { SearchType } from '../../assistantSearchTypes';

export const getFilteredCustomerChipList = (entities: AssistantCustomer[]): CustomerFilter[] => {
    const activeFilters: CustomerFilter[] = [];

    if (entities.some((entity) => entity.isVip)) {
        activeFilters.push(CustomerFilter.isVip);
    }

    if (entities.some((entity) => entity.isInHouse)) {
        activeFilters.push(CustomerFilter.isInHouse);
    }

    if (entities.some((entity) => entity.isPaymaster)) {
        activeFilters.push(CustomerFilter.isPaymaster);
    }
    return activeFilters;
};

export const getFilteredCompanyChipList = (entities: AssistantCompany[]): CompanyFilter[] => {
    const activeFilters: CompanyFilter[] = [];

    if (entities.some((entity) => entity.isTravelAgency)) {
        activeFilters.push(CompanyFilter.isTravelAgency);
    }
    return activeFilters;
};

export const getFilteredReservationChipList = (reservations: AssistantReservation[]): ReservationFilter[] => {
    const activeFilters: ReservationFilter[] = [];

    for (const filter in ReservationFilter) {
        if (
            reservations.some(
                (reservation) =>
                    reservation.timeState.toString() === ReservationFilter[filter as keyof typeof ReservationFilter] ||
                    reservation.serviceOrderState.toString() ===
                        ReservationFilter[filter as keyof typeof ReservationFilter]
            )
        ) {
            activeFilters.push(ReservationFilter[filter as keyof typeof ReservationFilter]);
        }
    }

    return activeFilters;
};

export const getFilteredBillChipList = (bills: AssistantBill[]): BillFilter[] => {
    const activeFilters: BillFilter[] = [];

    for (const filter in BillFilter) {
        if (
            bills.some(
                (bill) =>
                    bill.state.toString() === BillFilter[filter as keyof typeof BillFilter] ||
                    bill.type.toString() === BillFilter[filter as keyof typeof BillFilter]
            )
        ) {
            activeFilters.push(BillFilter[filter as keyof typeof BillFilter]);
        }
    }

    return activeFilters;
};

export const getFilteredResourceChipList = (resources: AssistantResource[]): SpaceFilter[] => {
    const activeFilters: SpaceFilter[] = [];

    for (const filter in SpaceFilter) {
        if (
            resources.some((resource) => resource.state?.toString() === SpaceFilter[filter as keyof typeof SpaceFilter])
        ) {
            activeFilters.push(SpaceFilter[filter as keyof typeof SpaceFilter]);
        }
    }

    return activeFilters;
};

export const useActiveFilterChips = (assistantSearchResult: AssistantSearchResult | null | undefined) => {
    if (!assistantSearchResult) {
        return {
            [SearchType.Reservation]: [],
            [SearchType.Company]: [],
            [SearchType.Customer]: [],
            [SearchType.Bill]: [],
            [SearchType.Resource]: [],
        };
    }
    const { reservations, bills, customers, companies, resources } = assistantSearchResult;

    const reservationActiveFilters = getFilteredReservationChipList(reservations);
    const billActiveFilters = getFilteredBillChipList(bills);
    const customerActiveFilters = getFilteredCustomerChipList(customers);
    const companyActiveFilters = getFilteredCompanyChipList(companies);
    const resourceActiveFilters = getFilteredResourceChipList(resources);

    return {
        [SearchType.Reservation]: reservationActiveFilters,
        [SearchType.Company]: companyActiveFilters,
        [SearchType.Bill]: billActiveFilters,
        [SearchType.Customer]: customerActiveFilters,
        [SearchType.Resource]: resourceActiveFilters,
    };
};
